import { renderBinaryRadioButtonGroup, } from '../../ui-kit/Calculator/renderBinaryRadioButtonGroup.js';
export const renderRegistrationType = (props) => renderBinaryRadioButtonGroup({
    ...props,
    items: [
        { id: 'remote', text: 'Дистанционно' },
        { id: 'office', text: 'Офис Банка' },
    ],
});
//# sourceMappingURL=renderRegistrationType.js.map